import { FC } from "react";

import { StationRouteWaypointPendingHost } from "../../../layout-edit/station-routes";
import { EditAreaWaypointsMapControlsInner } from "./edit-area-waypoints-map-controls.inner";
import { IUseEditAreaWaypointsMapControlsParams } from "./use-edit-area-waypoints-map-controls";

export const EditAreaWaypointsMapControls: FC<
  IUseEditAreaWaypointsMapControlsParams
> = props => (
  <StationRouteWaypointPendingHost>
    <EditAreaWaypointsMapControlsInner {...props} />
  </StationRouteWaypointPendingHost>
);
